import { h, Component } from 'preact';
import SearchInput from '../search-input';
import { withText } from 'preact-i18n';
import { withConfig } from '../../config';
import { trackingProvider, DIMENSION } from '@cube/track';

@withConfig([
	'search.sem.searchURL',
	'search.sem.queryParameter'
])
@withText({
	placeHolderText: 'searchSite'
})
@trackingProvider({
	[DIMENSION.componentpath]: 'Sem'
})
export default class Sem extends Component {

	render( props ) {
		return <SearchInput {...props} />;
	}
}
